import { useMemo, type ReactNode } from 'react';
import qrcode from 'qrcode-generator';

/** A scannable QR code, rendered as inline SVG (no canvas/image round-trip). */
export function QrCode({ text, size = 180 }: { text: string; size?: number }): ReactNode {
  const modules = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    const count = qr.getModuleCount();
    const dark: boolean[][] = [];
    for (let row = 0; row < count; row++) {
      const cells: boolean[] = [];
      for (let col = 0; col < count; col++) cells.push(qr.isDark(row, col));
      dark.push(cells);
    }
    return dark;
  }, [text]);

  const count = modules.length;
  const cell = size / count;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label="QR code"
      style={{ background: '#fff', borderRadius: 6, flexShrink: 0 }}
    >
      {modules.map((row, r) =>
        row.map((dark, c) =>
          dark ? (
            <rect key={`${r}-${c}`} x={c * cell} y={r * cell} width={cell} height={cell} fill="#000" />
          ) : null,
        ),
      )}
    </svg>
  );
}
